import moment from "moment";
import React, { useState, useEffect } from "react";
import { ConfigProvider, DatePicker } from "antd";
import { useSelector, useDispatch } from "react-redux";
import dayjs from "dayjs";
import utc   from "dayjs/plugin/utc";
import { GET_ISO_FORMAT,GET_ISO_FORMAT_WITH_DETAIL } from "../../../../../utils/helper";
import CustomFooter from "./CustomFooter";
import { updateVisibleBookingDetailsCalendar } from "../../../../../reducer/bookingReducer";
import { calculateNumberOfNights } from "../../../../../utils/bookingDetailsHelper";
import { TranslateText } from "../../../../../utils/translation";
dayjs.extend(utc);
const CustomCalendar = () => {
  const { RangePicker } = DatePicker;

  const {
    selectedCheckInDateTime,
    selectedCheckOutDateTime,
    visibleBookingDetailsCalendar,
    
    selectedCheckInAMPM,
    selectedCheckInHours, 
    selectedCheckInMin, 
    selectedCheckOutHours,
    selectedCheckOutMin,
    selectedCheckOutAMPM
  } = useSelector((store) => store.booking);

  const { hotelDetails } = useSelector((store) => store.login);
  const {zoneOffset} = hotelDetails || '+05:30';
  const dispatch = useDispatch();

  const [selectedCheckInDate, setSelectedCheckInDate] = useState("");
  const [selectedCheckOutDate, setSelectedCheckOutDate] = useState("");

  useEffect(() => {
    if (selectedCheckInDateTime) {
      setSelectedCheckInDate(selectedCheckInDateTime);
      setSelectedCheckOutDate(selectedCheckOutDateTime);
    } else {
      setSelectedCheckInDate(moment()?.utcOffset(zoneOffset).format("YYYY/MM/DD"));
      setSelectedCheckOutDate(moment()?.utcOffset(zoneOffset).add(1, "days").format("YYYY/MM/DD"));
    }
  }, []);

  const onSelectDate = (momentObj, dateString) => {
    
    setSelectedCheckInDate(GET_ISO_FORMAT(momentObj[0].$d));
    setSelectedCheckOutDate(GET_ISO_FORMAT(momentObj[1].$d));
  };
  return (
    <div
      className=" bg-[#F5F7FA] h-[55px] flex items-center gap-1 w-[70%] px-[12px] py-[4px] rounded-[8px] cursor-pointer relative"
      onClick={(e) => {
        dispatch(
          updateVisibleBookingDetailsCalendar(!visibleBookingDetailsCalendar)
        );
        e.stopPropagation();
      }}
    >
      <div onClick={(e) => e.stopPropagation()} className="absolute top-20 ">
        <ConfigProvider
          theme={{
            components: {
              DatePicker: {
                cellHeight: 25,
                cellWidth: 45,
              },
            },
          }}
        >
          <RangePicker
            picker="date"
            style={{
              border: "none",
              width: "0",
              height: "0",
              position: "absolute",
              padding: "0",
            }}
            showNow={false}
            suffixIcon={<></>}
            format="MMMMYYYY"
            open={visibleBookingDetailsCalendar}
            value={[dayjs(selectedCheckInDate), dayjs(selectedCheckOutDate)]}
            renderExtraFooter={() =>
              CustomFooter({
                selectedCheckInDate,
                setSelectedCheckInDate,
                selectedCheckOutDate,
                setSelectedCheckOutDate,
              })
            }
            separator={false}
            disabledDate={() => false}
            onChange={onSelectDate}
            allowClear={false}
          />
        </ConfigProvider>
      </div>

      <div
        className="flex flex-col justify-start items-start w-[50%]
    "
      >
        <div className="font-outfit font-[600] whitespace-nowrap text-[10px] leading-[15px] tracking-[2px] text-[#8F9BB3] uppercase">
          <TranslateText textKey={"check-in"} namespace="booking" />
        </div>
        <div className="font-outfit font-[500] text-[14px] leading-[20px]  text-[#222B45]">
          {Boolean(selectedCheckInDateTime)
            ? moment(selectedCheckInDateTime)?.utcOffset(zoneOffset)?.format("DD MMM YYYY")
            : moment()?.utcOffset(zoneOffset)?.format("DD MMM YYYY")}
        </div>
      </div>

      <div
        className=" px-[10px] py-[1px] rounded-[3px] bg-[#8F9BB3] 
     text-[#FFF] whitespace-nowrap  font-outfit font-[400] text-[12px] leading-[18px]   "
      >
        {calculateNumberOfNights(
          selectedCheckInDateTime,
          selectedCheckOutDateTime,
          hotelDetails
        ) || 1}{" "}
        N
      </div>

      <div
        className="flex flex-col justify-start items-end w-[50%]
    "
      >
        <div className="font-outfit font-[600] whitespace-nowrap text-[10px] leading-[15px] tracking-[2px] text-[#8F9BB3] uppercase">
          <TranslateText textKey={"check-out"} namespace="booking" />
        </div>
        <div className="font-outfit font-[500] text-[14px] leading-[20px]  text-[#222B45]">
          {Boolean(selectedCheckOutDateTime)
            ? moment(selectedCheckOutDateTime)?.utcOffset(zoneOffset)?.format("DD MMM YYYY")
            : moment()?.utcOffset(zoneOffset)?.add(1, "days")?.format("DD MMM YYYY")}
        </div>
      </div>
    </div>
  );
};

export default CustomCalendar;
